module.exports = __webpack_public_path__ + "static/ss14.66cd852f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss14.jpg
// module id = 1191
// module chunks = 81679748166845